// src/chatbot/components/StreamingIndicator.tsx
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import type { Branch } from "~/types/new_types";

interface StreamingIndicatorProps {
  theme: Branch["theme"];
}

const StreamingIndicator: React.FC<StreamingIndicatorProps> = ({ theme }) => {
  const { t } = useTranslation();
  const typingIndicatorSrc = "/output_video.gif";

  return (
    <motion.div
      className="inline-flex ml-2 h-8 w-8 items-center justify-center rounded-full overflow-hidden align-middle"
      style={{
        backgroundColor: `${theme.primaryColor}15`,
      }}
      initial={{ opacity: 0.8, scale: 0.9 }}
      animate={{
        opacity: [0.8, 1, 0.8],
        scale: [0.9, 1, 0.9],
      }}
      transition={{
        duration: 1.2,
        repeat: Infinity,
        ease: "easeInOut",
      }}
      role="img"
      aria-label={t("chatbot.typingIndicatorAlt", {
        defaultValue: "Assistant is responding…",
      })}
    >
      <img
        src={typingIndicatorSrc}
        alt=""
        className="h-full w-full object-cover"
        style={{
          transform: "scale(1.4)",
          filter: "brightness(1.1) saturate(1.1)",
        }}
      />
    </motion.div>
  );
};

export default StreamingIndicator;
